import React, { useState } from 'react'
import DefaultAvatar from 'assets/images/user_placeholder.png'
import styled, { ThemeContext } from 'styled-components'
import Box from 'shared/components/Box'
import ProtectedImage from 'shared/components/ProtectedImage'

type AvatarProps = {
  imageURL?: string
  defaultImageUrl?: string
  name?: string
}

export default function Avatar(props: AvatarProps) {
  const { imageURL = '', defaultImageUrl = '', name = '' } = props
  const [error, setError] = useState(false)

  return (
    <AvatarContainer className="avatar-container">
      {!error && (
        <ProtectedImage
          src={imageURL}
          defaultSrc={defaultImageUrl ? defaultImageUrl : DefaultAvatar}
          alt={name}
          onError={() => setError(true)}
        />
      )}
      {error && (
        <ProtectedImage src={imageURL} defaultSrc={defaultImageUrl ? defaultImageUrl : DefaultAvatar} alt={name} />
      )}
    </AvatarContainer>
  )
}

const AvatarContainer = styled(Box)`
  width: 80px;
  height: 80px;
  min-width: 80px;
  min-height: 80px;
  border-radius: 100%;
  overflow: hidden;

  align-items: center;
  justify-content: center;
  display: flex;
  img {
    width: 100%;
  }
`
